import React, { useState } from "react";
import { successMsg } from "../SuccessHandler";
import ErrorCodes from "../../constants/ErrorCodes";
import { useInsertFunctions } from "../../functions";

const NewLimitSetModal = ({
  data,
  getLimitSetList,
  setSessionNoLongerExists,
}) => {
  const [limitSetName, setLimitSetName] = useState("");
  const { insertLimitSetBetType } = useInsertFunctions();
  const [nameError, setNameError] = useState("");

  const limitSetChangeHandler = (e) => {
    if (e.target.value.trim()) {
      setNameError("");
    }
    setLimitSetName(e.target.value);
  };

  const handleInsertNewLimitSet = async () => {
    if (!limitSetName.trim()) {
      setNameError("Name is required");
      return;
    }

    const res = await insertLimitSetBetType(
      {
        LimitSetName: limitSetName.trim(),
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    }

    successMsg("Limit Set Inserted");
    setLimitSetName("");
    setNameError("");
    getLimitSetList();
  };

  return (
    <div>
      <div
        className="modal fade"
        id="newLimitSetModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          zIndex: 1051,
        }}
      >
        <div className="modal-dialog modal-xs" style={{ margin: "4rem auto" }}>
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ backgroundColor: "#5b6671", color: "#fff" }}
            >
              <h5
                className="modal-title"
                id="cloneLimitSetModal"
                style={{ cursor: "default" }}
              >
                New LimitSet
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => setLimitSetName("")}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div
                  className="col-sm-12 text-center"
                  style={{ cursor: "default" }}
                >
                  <p
                    className="lead"
                    style={{
                      color: "#8c8c8c",
                      fontSize: "16px",
                      margin: "2px",
                    }}
                  >
                    Enter the name of the new LimitSet
                  </p>
                  <div>
                    <div style={{ width: "90%", margin: "0 auto" }}>
                      <input
                        className={`form-control mt-2 ${nameError ? "is-invalid" : ""}`}
                        placeholder="Enter Name"
                        style={{ textAlign: "center" }}
                        value={limitSetName}
                        onChange={limitSetChangeHandler}
                        maxLength={50}
                      />
                      {nameError && (
                        <div className="invalid-feedback text-left">
                          {nameError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => handleInsertNewLimitSet()}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setLimitSetName("")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewLimitSetModal;
